import common from './common';


export default Object.assign({}, common);
